/* @flow */
import ListItem from 'components/ListItem.jsx';
import React from 'react';

import cx from 'classnames';

import styles from './styles/List.css';

export default class List extends React.Component {
  static propTypes = {
    horizontal: React.PropTypes.bool,
    delimiter: React.PropTypes.oneOf(['comma', 'dash', 'middot']),
    size: React.PropTypes.oneOf(['small']),
  };

  static defaultProps = {
    horizontal: false,
  };

  render() {
    const children = React.Children.map(this.props.children, child => {
      if (child && (child.type !== ListItem && child.type !== 'li')) {
        return <ListItem>{child}</ListItem>;
      }
      return child;
    });

    return (
      <ul
        className={cx({
          [styles.horizontal]: this.props.horizontal,
          [styles.commas]: this.props.delimiter === 'comma',
          [styles.dashes]: this.props.delimiter === 'dash',
          [styles.middot]: this.props.delimiter === 'middot',
          [styles.small]: this.props.size === 'small',
        }, this.props.className)}>
        {children}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/List.jsx